export const MADRID_PLACE_ID = 'ChIJgTwKgJcpQg0RaSKMYcHeNsQ'
export const VOID_PARKING_ICON_IMAGE = '/images/parking/void.webp'
